var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"auth-callback"},[_c('div',{staticClass:"auth-callback__label"},[_c('div',{staticClass:"ot-spinner"}),_c('h5',[_vm._v(_vm._s(_vm.$t('dashboard.common.state.loading'))+"...")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }